// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/styles/styles.scss
// module id = 40
// module chunks = 2